import { Spin } from "antd";

export default function InitialPageLoader({ label = "Loading…", className = "", compact = false, showLabel = true }) {
  return (
    <div className={`initial-page-loader ${compact ? "initial-page-loader--compact" : ""} ${className}`.trim()} role="status" aria-label={label} aria-live="polite">
      <Spin size={compact ? "small" : "large"} />
      {showLabel && <p>{label}</p>}
    </div>
  );
}
